export default __webpack_public_path__ + "static/B0280-dfd0b2e2643c5f5470611616a54397ab.png";